import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app.routes';
import { CanonicalLinkService } from './services/canonical-link.service';
import { provideI18n } from '../../../shared/i18n/provide-i18n';

export const appConfig: ApplicationConfig = {
  providers: [
    // Code review 43.8 — anchorScrolling is required for routerLink [fragment]
    // targets (e.g. docs cross-links to #device-authorization) to actually
    // scroll; the router's client-side pushState navigation does not trigger
    // the browser's native anchor-scroll on its own.
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideI18n(),
    // Story 53.7 — rel=canonical per page on the canonical brand origin.
    provideAppInitializer(() => inject(CanonicalLinkService).start()),
  ],
};
